<template>
  <div class="tender-switcher" @click.stop="switchExtendedInfo">
    <span v-if="tender.unread_messages_count" class="grey-500 text-sm">
      {{ $tc('new message', tender.unread_messages_count) }}
    </span>
    <ChevronIcon
      v-if="isActiveSwitcher"
      class="switcher-icon"
      :class="{ 'turn-over': showExtendedInfo }"
    />
  </div>
</template>

<script>
  import ChevronIcon from '@/assets/icons/chevron-down.svg';

  export default {
    name: 'TenderCardCompaniesInfo',
    components: {
      ChevronIcon,
    },
    props: {
      tender: {
        type: Object,
        required: true,
      },
      showExtendedInfo: {
        type: Boolean,
        default: false,
      },
      isActiveSwitcher: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      switchExtendedInfo() {
        if (this.isActiveSwitcher) {
          this.$emit('switch-extended-info');
        }
      },
    },
  };
</script>
